"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyYearlyDataTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const compliance_pool_types_1 = require("../../compliance-pool-types");
const common_styled_components_1 = require("../../../common-styled-components");
const amountUtils_1 = require("../../../../util/amountUtils");
const react_1 = require("react");
const Modal_1 = require("../../common/Modal");
const useEdit_1 = __importDefault(require("../../../../hooks/useEdit"));
const theme_1 = require("../../../../theme");
const lodash_1 = require("lodash");
const ExportCsvButton_1 = require("../ExportCsvButton");
const companyYearlyDataTableColumns = (isInAdminTools) => [
    {
        key: "year",
        label: "Year",
    },
    {
        key: "compliance_selling_price",
        label: "Selling price",
    },
    {
        key: "compliance_buying_price",
        label: "Buying price",
    },
    {
        key: "tools",
        label: "",
    },
].filter((c) => c.key !== "tools" || isInAdminTools === true);
const CellContent = ({ companyYearlyData, contentKey, isInAdminTools, removeCompanyYearlyData, editCompanyYearlyData, }) => {
    switch (contentKey) {
        case "tools":
            return isInAdminTools &&
                removeCompanyYearlyData &&
                editCompanyYearlyData ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => removeCompanyYearlyData(companyYearlyData), children: "Remove" }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => editCompanyYearlyData(companyYearlyData), children: "Edit" })] })) : ((0, jsx_runtime_1.jsx)("div", {}));
        default:
            return (0, jsx_runtime_1.jsx)("div", { children: companyYearlyData[contentKey] });
    }
};
const CompanyYearlyDataTable = ({ company, metadata, isInAdminTools, refresh, }) => {
    const [modal, setModal] = (0, react_1.useState)({});
    const [editStatus, executeEdit] = (0, useEdit_1.default)("admin/company_yearly_data.json", refresh);
    const addCompanyYearlyData = () => {
        setModal({
            type: "add",
            value: {
                company_id: company.id,
            },
        });
    };
    const editCompanyYearlyData = (companyYearlyData) => {
        setModal({
            type: "edit",
            value: companyYearlyData,
        });
    };
    const removeCompanyYearlyData = (companyYearlyData) => {
        setModal({
            type: "remove",
            value: companyYearlyData,
        });
    };
    const submit = (type, value) => {
        setModal({});
        if (type === "add") {
            if ((0, compliance_pool_types_1.isValidCompanyYearlyDataInput)(value)) {
                const data = {
                    id: null,
                    ...value,
                };
                executeEdit(data, "PUT");
            }
            else {
                alert("CompanyYearlyData not valid");
            }
        }
        if (type === "edit") {
            if ((0, compliance_pool_types_1.isValidCompanyYearlyDataInput)(value)) {
                const data = {
                    id: value.id,
                    ...value,
                };
                executeEdit(data, "PUT");
            }
            else {
                alert("CompanyYearlyData not valid");
            }
        }
        if (type === "remove") {
            if (value.id !== undefined) {
                const data = {
                    id: value.id,
                };
                executeEdit(data, "DELETE");
            }
        }
    };
    const companyYearlyData = company.years;
    const sortedCompanyData = (0, lodash_1.sortBy)(companyYearlyData, "year");
    const columns = companyYearlyDataTableColumns(isInAdminTools);
    const csvColumns = columns
        .filter((column) => column.key !== "tools")
        .map((column) => ({
        header: column.label,
        getValue: (datum) => {
            switch (column.key) {
                case "compliance_selling_price":
                case "compliance_buying_price":
                    return (0, amountUtils_1.formatNumber)(datum[column.key]) ?? "";
                default: {
                    const value = datum[String(column.key)];
                    return typeof value === "string" || typeof value === "number"
                        ? value
                        : "";
                }
            }
        },
    }));
    return (metadata && ((0, jsx_runtime_1.jsxs)("div", { children: [modal.type && ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { type: "companyYearlyData", isOpen: modal.type !== undefined, closeModal: () => setModal({}), modalType: modal.type, value: modal.value, submit: submit })), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Row, { gap: 2, children: [isInAdminTools && ((0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { onClick: addCompanyYearlyData, color: theme_1.theme.colors.blue, children: "+ Add yearly data" })), (0, jsx_runtime_1.jsx)(ExportCsvButton_1.ExportCsvButton, { rows: sortedCompanyData, columns: csvColumns, tableName: "company-yearly-data" })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Table, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TH, { children: c.label }, c.key))) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: sortedCompanyData.map((datum) => {
                            return ((0, jsx_runtime_1.jsx)(common_styled_components_1.TR, { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TD, { children: (0, jsx_runtime_1.jsx)(CellContent, { contentKey: c.key, companyYearlyData: datum, isInAdminTools: isInAdminTools, editCompanyYearlyData: isInAdminTools ? editCompanyYearlyData : undefined, removeCompanyYearlyData: isInAdminTools ? removeCompanyYearlyData : undefined }) }, c.key))) }, datum.id));
                        }) })] })] })));
};
exports.CompanyYearlyDataTable = CompanyYearlyDataTable;
